module.exports = __webpack_public_path__ + "img/bg.880da685.jpg";